import React from 'react';
import Form from '../../../components/common/Form';
import {Line} from 'react-chartjs-2';
import {labels, optionsTimeSpan} from "../../constants/constants";
import Loader from "../../utils/loader";
import Dashboard from "../Dashboard";
import ReactGA from "react-ga";
import {getCurrentUserId} from "../../../services/authService";
import ChartLoader from "../../utils/chart-loader";

class PerformanceReport extends Form {
    constructor(props) {
        super(props);
        let time_span = optionsTimeSpan.filter(src => (src.value.includes(this.props.time_span)))[0].value;
        this.state = {
            sentPerformanceReport: this.props.sentPerformanceReport,
            openedPerformanceReport: this.props.openedPerformanceReport,
            fb_related_data_by_month: this.props.fb_related_data_by_month,
            webpush_related_data_by_month: this.props.webpush_related_data_by_month,
            //slack_related_data_by_month: props.slack_related_data_by_month,
            labels_from_response: this.props.labels_from_response,
            errors: {},
            timeSpan: time_span,
            labels_to_use: this.props.labels_from_response
        };

        //Line.defaults.global.legend.labels.usePointStyle = true;

    }

    componentDidUpdate=()=> {
        if (this.state.sentPerformanceReport !== this.props.sentPerformanceReport) {
            this.setState({sentPerformanceReport: this.props.sentPerformanceReport});
            //this.setState({slack_related_data_by_month: this.props.slack_related_data_by_month});
        }

        if (this.state.openedPerformanceReport !== this.props.openedPerformanceReport) {
            this.setState({openedPerformanceReport: this.props.openedPerformanceReport});
        }

        if (this.state.fb_related_data_by_month !== this.props.fb_related_data_by_month) {
            this.setState({fb_related_data_by_month: this.props.fb_related_data_by_month});
        }

        if (this.state.webpush_related_data_by_month !== this.props.webpush_related_data_by_month) {
            this.setState({webpush_related_data_by_month: this.props.webpush_related_data_by_month});
        }

        if (this.state.labels_from_response !== this.props.labels_from_response) {
            this.setState({
                labels_from_response: this.props.labels_from_response,
                labels_to_use: this.props.labels_from_response
            });
        }

        if (this.props.time_span !== this.props.time_span) {
            let time_span = optionsTimeSpan.filter(src => (src.value.includes(this.props.time_span)))[0].value;
            this.setState({timeSpan: time_span});
        }
    }

    handleChangeSelectSearch = (selectedParam) => {

        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dashboard Performance Report - Change days',
        //     userId: getCurrentUserId(),
        //     label: selectedParam.target,
        //     nonInteraction: true
        // });
        const target = selectedParam.target;
        const value = target.textContent;
        let labels_to_use = this.state.labels_from_response;
        if (value.toString() !== "Last year") {
            labels_to_use = labels
        }
        this.setState({
            timeSpan: value,
            labels_to_use: labels_to_use
        });
        this.props.getSpanData(value);
    };

    render() {
        const {
            sentPerformanceReport, openedPerformanceReport,
            fb_related_data_by_month, webpush_related_data_by_month,
            //slack_related_data_by_month,
            labels_to_use
        } = this.state;

        const datasetsPerformanceReport = [
            {
                label: 'Sent',
                data: sentPerformanceReport,
                tension: 0,
                backgroundColor: [
                    '#344A5E'
                ],
                fill: false,
                borderColor: [
                    '#344A5E'
                ],
                borderWidth: 1,

                pointRadius: 4,
                pointBorderColor: 'rgba(52,74,94,0.2)',
                pointBorderWidth: '10',
                pointBackgroundColor: '#344A5E'
            },
            {
                label: 'Opened',
                data: openedPerformanceReport,
                tension: 0,

                backgroundColor: [
                    '#18A9E3'
                ],
                fill: false,
                borderColor: [
                    '#18A9E3'
                ],
                borderWidth: 1,

                pointRadius: 4,
                pointBorderColor: 'rgba(24,169,227,0.2)',
                pointBorderWidth: '10',
                pointBackgroundColor: '#18A9E3',
                pointCursor: 'pointer'
            }
        ];
        let dataPerformanceReport = {
            labels: labels_to_use,
            datasets: datasetsPerformanceReport
        };
        let optionsPerformanceReport = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                labels: {
                    usePointStyle: true
                    //borderRadius: 20,
                    //fontColor: 'blue',
                    //boxShadow: "0 0 0 5px rgba(38,170,225,0.2)",
                    //boxWidth: 5,
                    //fontSize: 20,
                    //fillStyle: 'red',
                    //color: "red",
                    //width: 0,
                    //pointStyleBackgroundColor: 'red'
                }
            },
            tooltips: {

                // Disable the on-canvas tooltip
                enabled: false,

                custom: function (tooltipModel) {
                    //console.log("tooltipModel", tooltipModel);
                    // Tooltip Element
                    var tooltipEl = document.getElementById('performance-tooltip');

                    // Create element on first render
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'performance-tooltip';
                        tooltipEl.innerHTML = "<tooltip></tooltip>";
                        document.body.appendChild(tooltipEl);
                    }

                    // Hide if no tooltip
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set caret Position
                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltipModel.body) {
                        var titleLines = tooltipModel.title || [];
                        var bodyLines = tooltipModel.body.map(getBody);

                        var innerHtml = '';

                        titleLines.forEach(function (title) {
                            innerHtml += '<table class="tooltip-table-title tooltip-table m-m-b">' +
                                '    <thead>' +
                                '    <tr>' +
                                '       <th>' + title + '</th>' +
                                '       <th><span class="far fa-envelope"></span> / <span class="far fa-envelope-open"></span></th>' +
                                '       <th>(%)</th> ' +
                                '    </tr> ' +
                                '    </thead> ' +
                                '</table> ' +
                                '\n' +
                                '\n' +
                                fb_related_data_by_month[title] +
                                webpush_related_data_by_month[title] +
                                '\n' +
                                '\n';
                        });
                        innerHtml += '';

                        bodyLines.forEach(function (body, i) {
                            innerHtml += '';
                        });

                        var tableRoot = tooltipEl.querySelector('tooltip');
                        tableRoot.innerHTML = innerHtml;
                    }

                    // `this` will be the overall tooltip
                    var position = this._chart.canvas.getBoundingClientRect();

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.position = 'fixed';
                    tooltipEl.style.left = position.left + tooltipModel.caretX + 'px';
                    tooltipEl.style.top = position.top + tooltipModel.caretY + 'px';
                    tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                    tooltipEl.style.backgroundColor = "rgba(52, 74, 94, 0.9)";
                    tooltipEl.style.color = "#fff";
                    tooltipEl.style.borderRadius = '4px';
                    tooltipEl.style.padding = '20px';
                }
            }
        };
        //console.log("optionsPerformanceReport", optionsPerformanceReport.legend.labels.borderRadius);
        return (
            <div className="col-xl-9">
                <div className="row m-m-b">
                    <div className="col-xs-6">
                        <p>Performance Report</p>
                    </div>
                    <div className="col-xs-6 select-holder">
                        <div className="nice-select" tabIndex="0">
                            <span className="current">{this.state.timeSpan}</span>
                            <ul className="list">
                                {
                                    optionsTimeSpan.map(option => (
                                        <li key={option.value}
                                            name={option.value}
                                            id={option.value}
                                            onClick={this.handleChangeSelectSearch}
                                            className={(option.text === this.state.timeSpan) ? "option active selected" : "option"}>
                                            {option.text}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                <img className="chart-blur" src="/img/chart-1-rotate.png" alt="Rotate For Chart 1"/>
                {this.props.loadingSource ?
                    <ChartLoader/>

                    :

                    (
                        this.props.loader ?

                            <ChartLoader/>

                            :

                           <Line data={dataPerformanceReport} options={optionsPerformanceReport}/>

                    )
                }
            </div>
        )
    }
}

export default PerformanceReport

